export const concatUrl = (path) => {
  const origin = window.location.origin.replace(/\/+$/, ''); 
  return `${origin}${path}`;
}